<h1>Lista de Usuarios</h1>
<div fxLayout="row" fxLayoutAlign="space-between center">
  <div fxLayout="row">
    <mat-form-field appearance="outline" class="full-width-30vw" floatLabel="always"
      matTooltip="Filtro por cualquier columna de la tabla" matTooltipPosition="above">
      <mat-label> Filtro General </mat-label>
      <input matInput [formControl]="descriptionSearch" (keyup)="applyFilterDetails($event)"
        placeholder="Valor a filtrar..." #input>
    </mat-form-field>
  </div>
</div>
<div class="table-overflow-100">
  <table mat-table [(ngModel)]="dataSourceFilters" [dataSource]="dataSourceFilters" matSort matSortActive="username"
    matSortDirection="asc"
    matSortDisableClear class="mat-elevation-z8">
    <ng-container matColumnDef="username">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-header-cell-datalaing"> Usuario </th>
      <td mat-cell *matCellDef="let element"> {{element.username}} </td>
    </ng-container>
    <ng-container matColumnDef="fullName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-header-cell-datalaing"> Nombre y Apellido </th>
      <td mat-cell *matCellDef="let element"> {{element.fullName}} </td>
    </ng-container>
    <ng-container matColumnDef="isExpired">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-header-cell-datalaing"> Estatus </th>
      <td mat-cell *matCellDef="let element" align="center">
        <ng-container *ngIf="element.isExpired; else elseTemplate">Inactivo</ng-container>
        <ng-template #elseTemplate>Activo</ng-template>
      </td>
    </ng-container>
    <ng-container matColumnDef="initDateLicense">
      <th mat-header-cell *matHeaderCellDef mat-sort-header fxHide.xs class="mat-header-cell-datalaing"> Fecha Desde </th>
      <td mat-cell *matCellDef="let element" align="center"> {{element.initDateLicense | date:'dd/MM/yyyy'}} </td>
    </ng-container>
    <ng-container matColumnDef="endDateLicense">
      <th mat-header-cell *matHeaderCellDef mat-sort-header fxHide.xs class="mat-header-cell-datalaing"> Fecha Hasta </th>
      <td mat-cell *matCellDef="let element" align="center"> {{element.endDateLicense | date:'dd/MM/yyyy'}} </td>
    </ng-container>
    <ng-container matColumnDef="license">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-header-cell-datalaing"> Cantidad Licencias </th>
      <td mat-cell *matCellDef="let element" align="center"> {{element.license}} </td>
    </ng-container>
    <ng-container matColumnDef="rifCompany">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-header-cell-datalaing"> RIF </th>
      <td mat-cell *matCellDef="let element" align="center"> {{element.rifCompany}} </td>
    </ng-container>
    <ng-container matColumnDef="companyName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-header-cell-datalaing"> Razón Social </th>
      <td mat-cell *matCellDef="let element"> {{element.companyName}} </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="mat-header-medium"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="verDetalle(row)"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="11">No hay datos que coincidan con la búsqueda "{{ filterValue }}"</td>
    </tr>
  </table>
</div>
<mat-paginator [pageSizeOptions]="[25, 50, 100]" aria-label="Select page of users"></mat-paginator>
